<template>
  <BasicModalWindow ref="modal_component" class="attach-modal" v-if="!meo_cloud_visible">
      <template #title>
          <span>{{Language.say('composer.modals.attachments')}}</span>
      </template>
      <template #body>
          <ComposeAttachmentsFilesList
            :compose_controller="compose_controller"
          />

          <ComposeAttachmentsSapoTransfer ref="sapo_transfer_component"
            :compose_controller="compose_controller"
          />
      </template>
      <template #footer>
          <div class="sub-footer">
              <ActionButton @click="onSapoTransferUpload()" class=' ' text="composer.modals.attach_sapotransfer" />
          </div>
          <ActionButton @click="onDismiss()" class='main-action push-right' text="composer.modals.finish" />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import {ref}                          from "vue";
  import {defineProps}                  from "vue";
  import ComposeAttachmentsSapoTransfer from "./Partials/ComposeAttachmentsSapoTransfer.vue";
  import ComposeAttachmentsFilesList    from "./Partials/ComposeAttachmentFilesList.vue";
  import BasicModalWindow               from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                   from '@/vue/Elements/Buttons/ActionButton.vue';
  import Language                       from '@/js/Shared/Language/Language.js';


  const props = defineProps({
    compose_controller : {
      required: true,
    },

    meo_cloud_controller : {
      required: true,
    }
  })

  const modal_component         = ref();
  const sapo_transfer_component = ref();
  const meo_cloud_visible       = ref(false);

  const onDismiss = () => {
    modal_component.value.close();
  }

  const onSapoTransferUpload = () => {
    sapo_transfer_component.value.upload();
  }

</script>
